import { render, staticRenderFns } from "./spaceTemplateModal.vue?vue&type=template&id=57c274d2&"
import script from "./spaceTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./spaceTemplateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports